import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { OneSignalService } from 'src/services/onesignal.service';

@Component({
  selector: 'app-question-response-correction-dialog',
  templateUrl: './question-response-correction-dialog.component.html',
  styleUrls: ['./question-response-correction-dialog.component.scss']
})
export class QuestionResponseCorrectionDialogComponent implements OnInit {

  currentTest: any = null;
  questions: Array<any> = [];
  submiting: boolean = false;
  answeredQuestions: Array<any> = [];
  processListId: string;
  userId: string = null;
  corrections: any = {};
  processList: any;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<QuestionResponseCorrectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private oneSignalService: OneSignalService,
  ) { 
    this.currentTest = data.test;
    this.processListId = data.processList;
    this.userId = data.userId;
    this.processList = data.ProcessListName;
  }

  ngOnInit(): void {

    this.getQuestions();

  }

  getQuestions() {

    const params = { 
      id: this.currentTest.id,
      answered: true
    }
    
    this.http.list('user_process_list:question', params)
      .subscribe(
        (result: any) => { 
          
          this.questions = result.data;
          this.getResponses();
        },
        err => this.errorReport.showMessage(err)
      );

  }

  getResponses() {

    const params = { 
      test: this.currentTest.id,
      userId: this.userId,
      processList: this.processListId
    }
    
    this.http.list('user_process_list:response', params)
      .subscribe(
        (result: any) => {
          //const { data } = result;
          //this.answeredQuestions = data;

          this.answeredQuestions = result['data'];
          
          //corrige automaticamente
          this.answeredQuestions.forEach((option: any) => {
            if (option.evaluated === 1) {
              this.corrections[option.id] = option.approved == 1? true:false; // Adiciona ao array corrections
            }
          });

          

        },
        err => this.errorReport.showMessage(err)
      )

  }

  getAnsweredQuestion(question) {    
    
    const response = this.answeredQuestions.filter(_question => _question.selection_test_question == question.id/* && _question.selection_test_question_option == question.id*/);
    
    return response;

  }

  approveResponse(option, approved) {

    const params = {
      id: option.id,
      approved
    }
    
    this.http.save('user_process_list:response_update', params)
      .subscribe(
        (result: any) => {
          if(result.type === 'OK') {
            
            this.snackbar.open(
              approved ? 'Resposta aprovada com sucesso!': 'Resposta rejeitada com sucesso!',
              'OK',
              { duration: 3000 }
            );
            this.getQuestions();
            this.corrections[option.id] = approved;
            this.canConclude();
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  conclude(approved = true) {

    if(!confirm('Certeza que deseja concluir a correção desse questionário'))
      return;

    const params = {
      userId: this.userId,
      test: this.currentTest.id,
      processList: this.processListId
    }
    
    this.http.save('user_process_list:conclude', params)
      .subscribe(
        (result: any) => {
          if(result.type === 'OK') {

            this.http.save('onsignal:getUser', {leads: { lead_ids: [this.userId] }})
            .subscribe(
              (result: any) => {
                if (result.type === 'OK') {
                  const signatureIds = result.data.map((item: any) => item.signature_id); // Extrai os signature_ids
                  
                  const notification_for_all = null;
                  const title = 'Teste Avaliado';
                  const fullname = null;
                  const message = this.oneSignalService.listMessage(8, fullname, this.processList.name, this.currentTest.name );
                  
                  // Envia os dados para a função do backend que lida com as notificações
                  this.oneSignalService.sendNotification(signatureIds, title, message, notification_for_all)
                  .subscribe(
                    (result: any) => {
                      if (result.type === 'OK') {
                        this.oneSignalService.listNotification();
                      } else {
                        console.error('Erro ao enviar notificação para o candidato sobre o teste avaliado');
                      }
                    },
                    err => {
                      console.error('Erro ao enviar notificação ao candidato teste avaliado', err);
                      this.errorReport.showMessage(err);
                    }
                  );
                } else {
                  console.error('Erro ao obter dados para o envio da notificação');
                }
              },
              err => this.errorReport.showMessage(err)
            )

            this.snackbar.open('Concluído', 'OK', { duration: 3000 });
            this.dialogRef.close(true);
          }

        },
        err => this.errorReport.showMessage(err)
      )

  }

  canConclude() {

    return this.answeredQuestions.every(question => question.evaluated == 1)

  }

}
